export default __webpack_public_path__ + "static/media/logo.ba8e08f9.svg";